<template>
    <div class="chatList">
        <div class="scroll-box">
            <vue-scroll :ops="ops" @handle-scroll="handleScroll" v-if="userList.length>0">
                <div class="chat-item" v-for="(item,index) in userList" :key="index" :class="{active:curId == item.id}"
                    @click="selectUser(item)">
                    <div class="avatar">
                        <img :src="item.show_avatar" alt="">
                        <div class="status" :class="{off:item.online == 0}"></div>
                    </div>
                    <div class="user-info">
                        <div class="hd">
                            <span class="name line1">
                                <el-badge :value="item.no_read>0?item.no_read:''" class="item">
                                    <div :title="item.show_name" class="itemnick">{{item.show_name}}</div>
                                </el-badge>
                            </span>
                            <template>
                                <span class="label wechat">公众号</span>
                            </template>
                        </div>
                        <div class="bd line1">
                            <template
                                v-if="item.msg_type =='text'&&item.show_text[0]!='{'">{{item.show_text}}</template>
                            <template v-else-if="item.msg_type =='text'&&item.show_text[0]=='{'">[内容]</template>
                            <template v-if="item.msg_type =='image'">[图片]</template>
                            <template v-if="item.order_status =='1'">待接诊</template>
                            <template v-if="item.message_type ==5">[商品]</template>
                            <template v-if="item.message_type ==6">[订单]</template>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="time" v-if="item.order_status!=1">{{item.end_up_time}}</div>
                        <div class="time" v-else>
                            <el-button size="mini" @click.stop="docjs(item)" type="text">接受</el-button>
                            <!-- <el-button size="mini" @click="docjs()" style="color:red" type="text">拒绝</el-button> -->
                        </div>
                        <!-- <div class="num">
                            <a href="#" class="demo-badge"></a>
                        </div> -->
                    </div>
                </div>
            </vue-scroll>
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    import {
        HappyScroll
    } from 'vue-happy-scroll'
    export default {
        name: "chatList",
        props: {
            userOnline: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            newRecored: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            searchData: {
                type: String,
                default: ''
            }
        },
        components: {
            HappyScroll,
            // empty
        },
        watch: {
            userOnline: {
                handler(nVal, oVal) {
                    if (nVal.hasOwnProperty('to_uid')) {
                        this.userList.forEach((el, index) => {
                            if (el.to_uid == nVal.to_uid) {
                                el.online = nVal.online
                                if (nVal.online == 1) {
                                    this.$Notice.info({
                                        title: '上线通知',
                                        desc: `${el.nickname}上线`
                                    });
                                }

                            }
                        })
                    }
                },
                deep: true
            },
            searchData: {
                handler(nVal, oVal) {
                    if (nVal != oVal) {
                        this.nickname = nVal
                        this.page = 1
                        this.isScroll = true
                        this.userList = []
                        this.isSearch = true
                        this.getList()
                    }
                },
                deep: true
            }
        },
        data() {
            return {
                doc_id: '',
                // 
                page: 1,
                limit: 15,
                isScroll: true,
                // 
                userList: [],
                curId: '',
                isSearch: false,
                ops: {
                    vuescroll: {
                        mode: 'native',
                        enable: false,
                        tips: {
                            deactive: 'Push to Load',
                            active: 'Release to Load',
                            start: 'Loading...',
                            beforeDeactive: 'Load Successfully!'
                        },
                        auto: false,
                        autoLoadDistance: 0,
                        pullRefresh: {
                            enable: false
                        },
                        pushLoad: {
                            enable: true,
                            auto: true,
                            autoLoadDistance: 10
                        }
                    },
                    bar: {
                        background: '#393232',
                        opacity: '.5',
                        size: '5px'
                    }
                },
                searchValue: '',
                doc_data: '',
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        created() {
            // this.connect()
        },
        mounted() {
            let vue = this

            vue.bus.$on('getdoc', data => {
                this.doc_data = data
                this.doc_id = data.id
                this.userList = []
                vue.getList()
                this.curId = ''
            })
            vue.bus.$on('change', data => {
                this.searchValue = data
                this.getList2()
            })
        },
        methods: {

            // async connect(t) {
            //     let that=this
            //     this.$openws.ws.msg = async function (user_id, kefu_id, text) {
            //         console.log(text);
            //          if (text.list && text.list.length > 0) {
            //             that.userList = text.list
            //         }
            //     };
            // },
            getList() {
                // if (!this.isScroll) return
                let data = this.doc_data ? this.doc_data : JSON.parse(sessionStorage.getItem('doc_data'))
                let token = sessionStorage.getItem('token')
                this.$openws.ws.send('index/server/docInquiryList', data, `manager_${token}`)
            },
            getList2() {
                axios.post('/admin/pc/inquiry/index', {
                    page: this.page,
                    page_count: this.limit,
                    // doc_id: this.doc_id,
                    search: this.searchValue,
                    type: 0,
                    user: this.doc_data ? this.doc_data : JSON.parse(sessionStorage.getItem('doc_data'))

                }, {
                    token: true
                }).then(res => {
                    this.userList = res.data.data.list
                })
            },

            // 选择用户
            selectUser(item) {
                if (item.order_status == 1) {
                    this.docjs(item)
                    return
                }
                let vue = this
                vue.$parent.page = 1
                this.curId = item.id
                vue.$emit('setDataId', item)
            },
            docjs(item) {
                this.$confirm('是否接受该咨询订单, 是否继续?', '提示', {
                    confirmButtonText: '接受',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios.post('/admin/pc/DoctorInquiry/reception', {
                        id: item.id,
                        user: this.doc_data ? this.doc_data : JSON.parse(sessionStorage.getItem(
                            'doc_data'))
                    }, {
                        token: true
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.getList()
                            this.$parent.page = 1
                            this.curId = item.id
                            this.$emit('setDataId', item)
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    })

                }).catch((err) => {
                    console.log(err);
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            clearbindnum(id) {
                this.userList.forEach(element => {
                    if (id == element.id) {
                        element.num = ''
                    }
                });
            },
            handleScroll(vertical, horizontal, nativeEvent) {
                if (vertical.process == 1) {
                    // this.getList()
                }
            },
            getdoc(doc_id) {
                this.doc_id = doc_id
                this.getList()
            }
        },
        destroyed() {
            this.bus.$off()
        }
    }
</script>

<style lang="scss" scoped>
    .chatList {
        display: flex;
        flex-direction: column;
        width: 320px;
        height: 742px;
        border-right: 1px solid #ECECEC;

        .scroll-box {
            flex: 1;
            height: 500px;
            overflow: hidden;

            .chat-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 12px 10px;
                height: 74px;
                box-sizing: border-box;
                border-left: 3px solid transparent;
                cursor: pointer;

                &.active {
                    background: #EFF0F1;
                    border-left: 3px solid #1890FF;
                }
            }
        }
    }




    .avatar {
        position: relative;
        width: 40px;
        height: 40px;

        img {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }

        .status {
            position: absolute;
            right: 3px;
            bottom: 0;
            width: 8px;
            height: 8px;
            background: #48D452;
            border: 1px solid #fff;
            border-radius: 50%;

            &.off {
                background: #999999;
            }
        }

    }

    .user-info {
        width: 180px;
        margin-left: 12px;
        margin-top: 5px;
        font-size: 16px;

        .hd {
            display: flex;
            align-items: center;
            color: rgba(0, 0, 0, 0.65);
            width: 100%;

            .name {
                width: 68%;

            }

            .item {
                width: 100%;
            }

            .itemnick {
                font-size: 12px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .label {
                margin-left: 5px;
                color: #3875EA;
                font-size: 12px;
                background: #D8E5FF;
                border-radius: 2px;
                padding: 1px 5px;

                &.H5 {
                    background: #FAF1D0;
                    color: #DC9A04;
                }

                &.wechat {
                    background: rgba(64, 194, 73, 0.16);
                    color: #40C249;
                }

                &.pc {
                    background: rgba(100, 64, 194, 0.16);
                    ;
                    color: #6440C2;
                }
            }
        }

        .bd {
            margin-top: 3px;
            font-size: 12px;
            color: #8E959E;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .right-box {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        color: #8E959E;

        .time {
            font-size: 12px;
        }

        .num {
            margin-right: 12px;
        }

    }


    .chart-scroll {
        margin-top: -10px;
    }
</style>